module.exports = __webpack_public_path__ + "static/media/picture14.58bc00b3.png";